
import { Link } from "react-router-dom";
import { HOME_ROUTE } from "../../../routes/web/rootRoutes";
import { useSelector } from "react-redux";
import { getFileUrl } from "../../../utils/helper";
import { BRAND_NAME } from "../../../utils/constant";
import productImg from '../../../assets/logo.jpg';


const Logo = () => {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const LOGO = getFileUrl(setting?.site_settings?.site_logo);
  return (
    <Link to={HOME_ROUTE} className="order-0 md:order-1">
      <div className="flex items-center justify-center w-[90px] h-[90px]">
        <img src={productImg} alt={BRAND_NAME} className="h-[80px] shadow rounded-full"/>
      </div>
    </Link>
  );
};

export default Logo;
